<app-ice-card [type]="type">
  <div
    class="ice-alert"
    [ngClass]="{ 'click-link': isClickable }"
    [ngStyle]="{ 'grid-template-columns': iconName ? 'auto 1fr' : '1fr', padding: padding }"
  >
    @if (iconName) {
      <mat-icon [ngStyle]="{ width: iconWidth, height: iconHeight ? iconHeight : iconWidth }" [svgIcon]="iconName" />
    }
    <div class="content">
      <div class="heading">
        <ng-content select="[heading]" />
      </div>
      <div>
        <ng-content />
      </div>
    </div>
  </div>
</app-ice-card>
